import styled from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';

export const StyledListingSummaryPage = styled('div')`
  min-height: 100vh;
  background: ${({ theme }) => theme.colorBgContainer};

  .summary-container {
    max-width: ${breakpoints.lg}px;
    margin: 0 auto;
    padding: 40px 24px;
  }

  .summary-header {

    .header-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
    }

  .title-section {
      flex: 1;

      h1 {
        font-size: 24px;
        font-weight: 600;
        color: ${({ theme }) => theme.colorText};
        margin: 0 0 8px 0;
      }

      .identifier {
        font-size: 14px;
        color: ${({ theme }) => theme.grey};
      }
    }

    .actions-section {
      display: flex;
      gap: 12px;
      align-items: center;
    }
  }

  .info-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
    margin-bottom: 32px;
    background: ${({ theme }) => theme.colorBgLayout};
    border-radius: 8px;

    .info-item {
      .info-label {
        font-size: 12px;
        font-weight: 500;
        color: ${({ theme }) => theme.grey};
        text-transform: uppercase;
        margin-bottom: 4px;
      }

      .info-value {
        font-size: 14px;
        color: ${({ theme }) => theme.colorText};
        font-weight: 500;
      }
    }
  }

  .products-section {
    h2 {
      font-size: 18px;
      font-weight: 600;
      color: ${({ theme }) => theme.colorText};
      margin-bottom: 16px;
    }

    .ant-table-wrapper {
      .ant-table {
        background: transparent;
      }

      .ant-table-thead > tr > th {
        background: ${({ theme }) => theme.colorBgLayout};
        font-weight: 600;
        font-size: 13px;
      }

      .ant-table-tbody > tr > td {
        font-size: 14px;
      }

      .fully-delivered {
        opacity: 0.5;
      }
    }

    .quality-marks-cell {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      align-items: center;

      .quality-mark {
        width: 20px;
        aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};

        .ant-image {
          display: flex;
          width: 100%;
          height: 100%;

          img {
            object-fit: contain;
          }
        }
      }
    }
  }

  .farm-name-item,
  .listing-link-item {
    grid-column: 1 / -1;
  }

  .listing-link {
    color: ${({ theme }) => theme.brand01};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

`;
